/*
 * Copyright (c) 2020 brightlamp
 */

export default
{
    namespaced: true,
    state:
    {
        waiting: false,
        snackbar:
        {
            show: false,
            text: '',
            color: 'black',
            buttonTextColor: 'white',
            delay: 5000
        }
    },
    mutations:
    {
        WAITING(state, payload)
        {
            state.waiting = payload
        },
        SHOW_SNACKBAR_SUCCESS(state, payload)
        {
            state.snackbar.show = true;
            state.snackbar.text = payload;
            state.snackbar.color = 'green'
        },
        SHOW_SNACKBAR_WARN(state, payload)
        {
            state.snackbar.show = true;
            state.snackbar.text = payload;
            state.snackbar.color = 'yellow darken-4'
        },
        SHOW_SNACKBAR_WARN_DELAY(state, payload)
        {
            state.snackbar.show = true;
            state.snackbar.text = payload.message;
            state.snackbar.color = 'yellow darken-4';
            state.snackbar.delay = payload.delay
        },
        SHOW_SNACKBAR_ERROR(state, payload)
        {
            state.snackbar.show = true;
            state.snackbar.text = payload;
            state.snackbar.color = 'red'
        },
        HIDE_SNACKBAR(state)
        {
            state.snackbar.show = false
        }
    }
}

function isBeforeCutoff(lastTime, cutoffHours)
{
    if (lastTime)
    {
        const now = new Date;
        const expiryDate = new Date(lastTime);
        expiryDate.setHours(expiryDate.getHours() + cutoffHours);
        return expiryDate > now
    }
    return false
}

export { isBeforeCutoff }